import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  CardImg,
  Collapse,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
} from 'reactstrap'
import { DropdownItem, DropdownMenu, DropdownToggle } from '@byscott-io/corebyscott'
import Brand from '../../../images/brand.png'
import Tooltip from '../Shared/Tooltip'
import Dropdown from '../Shared/Dropdown'
import { withUserStore } from '../../contexts/UserStore'
import Lex from '../Shared/Lex'
import { withTour } from '../../contexts/tours'

const Header = ({ userStore, tourActions }) => {
  const [accountName, setAccountName] = useState(userStore.account?.name)
  const navigate = useNavigate()
  const appNavigate = userStore.appNavigate
  // Derive cog-vs-avatar from state instead of calling setState during render.
  // The old `if (avatarUrl) setShowCog(false)` inside avatarOrCog() ran during
  // render and swapped <i> -> <img>, which triggers a React removeChild crash
  // (only once a real avatar loads, so CI/test users never hit it). (#635)
  const [imgFailed, setImgFailed] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  const user = userStore.user
  const showCog = imgFailed || !user?.avatarUrl

  useEffect(() => {
    setAccountName(userStore.account?.name)
  }, [userStore.account?.name])

  const avatarOrCog = () => (
    showCog
      ? <i className="fas fa-gear" />
      : (
        <img
          className="circle"
          width="25px"
          alt="Settings"
          onError={() => setImgFailed(true)}
          src={user?.avatarUrl}
        />
      )
  )

  return (
    <div className="sticky-top page-header container">
      <Navbar className="no-padding" expand="md">
        <NavbarBrand
          id="home-link" style={{ padding: 0 }} className="times-new-roman"
          onClick={() => appNavigate()}
        >
          <h4 className="inline-block">
            <CardImg src={Brand} className="width40 margin-right-5px" />{accountName || 'rioritize.Plus'}&nbsp;
            <span className="text-muted"> Do What Matters</span>
          </h4>
        </NavbarBrand>
        <Tooltip delay={250} target="home-link">
          Home / Dashboard...
        </Tooltip>
        <NavbarToggler onClick={() => setIsOpen(!isOpen)} />
        <Collapse className="d-flex justify-content-end" isOpen={isOpen} navbar>
          <Nav navbar />
          <Nav>
            <NavItem className="hover-item nav-button">
              <NavLink id="goals-link" onClick={() => appNavigate('goals')}>
                <i className="fas fa-book" /> My <Lex term="goal" plural />...
              </NavLink>
              <Tooltip delay={250} target="goals-link">
                My <Lex term="goal" plural />...
              </Tooltip>
            </NavItem>
            {/* eslint-disable-next-line no-constant-binary-expression */}
            {false && (
              <NavItem className="hover-item nav-button">
                <NavLink id="tasks-link" onClick={() => appNavigate('tasks')}>
                  <i className="fas fa-list-check" /> <Lex term="task" plural />
                </NavLink>
                <Tooltip delay={250} target="tasks-link">
                  <Lex term="task" plural />...
                </Tooltip>
              </NavItem>)}
            <NavItem className="nav-icon">
              <NavLink id="help-link" data-cy="nav-help" onClick={() => appNavigate('help')}>
                <i className="fas fa-question" />
              </NavLink>
              <Tooltip delay={250} target="help-link">
                Help...
              </Tooltip>
            </NavItem>
            <NavItem className="nav-icon">
              <NavLink id="tour-link" onClick={() => tourActions.setShowTour('AccountCreateTour')}>
                <i className="fas fa-circle-info" />
              </NavLink>
              <Tooltip delay={250} target="tour-link">
                Guided Tour...
              </Tooltip>
            </NavItem>
            <Dropdown className={'cbs-scope nav-icon' + (showCog ? '' : ' avatar')}>
              <DropdownToggle id="menu-link" data-cy="user-menu-toggle" nav caret>
                {avatarOrCog()}
              </DropdownToggle>
              <DropdownMenu end>
                <DropdownItem data-cy="nav-profile" onClick={() => navigate('/app/profile')}>
                  <Lex term="my-profile" />
                </DropdownItem>

                <DropdownItem divider />
                <DropdownItem data-cy="nav-goals" onClick={() => appNavigate('goals')}>
                  <Lex term="goal" plural />
                </DropdownItem>
                <DropdownItem data-cy="nav-tasks" onClick={() => appNavigate('tasks')}>
                  <Lex term="task" plural />
                </DropdownItem>

                <DropdownItem divider />
                <DropdownItem data-cy="nav-priorities" onClick={() => appNavigate('priorities')}>
                  <Lex term="priority" plural />
                </DropdownItem>
                <DropdownItem data-cy="nav-strategies" onClick={() => appNavigate('strategies')}>
                  <Lex term="strategy" plural />
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem data-cy="nav-organization" onClick={() => appNavigate('organization')}>
                  <Lex term="organization-settings" />
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem data-cy="nav-organizations" onClick={() => navigate('/app/organizations')}>My
                  Organizations
                </DropdownItem>
                {userStore.accounts?.map(a => a.id === userStore.account?.id ? <DropdownItem key={a.id}>{'> ' + a.name}</DropdownItem> : <DropdownItem key={a.id} onClick={() => userStore.switchAccounts(a.id, () => appNavigate('/app/' + a.id))}> {a.name}</DropdownItem>)}
                <DropdownItem divider />
                <DropdownItem onClick={() => userStore.logout()}>
                  <Lex term="logout" />
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  )
}

export default withUserStore(withTour(Header))
